import ajax from '../../../utils/ajax';

async function login(returnUrl: string) {
  const response = {
    isSuccessful: false,
    redirectUrl: '',
    errorMessage: '',
    };

    try {

    const { redirectUrl } = await ajax.post('/api/account/facebooklogin', { returnUrl });

    response.redirectUrl = redirectUrl;
    response.isSuccessful = true;
  } catch (jqxhr) {
    if (jqxhr.status >= 500) {
      throw new Error();
    }

    response.errorMessage = jqxhr.responseJSON?.message;
  }

  return response;
}

export default {
  login,
};
